import React, { useState } from "react";
import { Button, CircularProgress, Box, Typography } from "@mui/material";
import { getIconComponent } from "@/Utils/getIconComponent";

export const BlackButton = ({
  label,
  disabled,
  loading,
  type = "submit",
  onClick,
  iconName = null,
  iconPosition = "start",
  startAdornment = null,
  endAdornment = null,
  iconSpacing = 1, // default: 8px
  sx = {},
  width = "10%",
  height = 40,
  loadingText = "Loading...",
  ...props
}) => {
  const IconComponent = iconName
    ? getIconComponent(iconName, {
        color: "var(--gary-0)",
        size: 20,
        style: { fontWeight: "bold" },
      })
    : null;

  const defaultStyles = {
    backgroundColor: "var(--brand-600)",
    color: "var(--gray-50)",
    textTransform: "none",
    borderRadius: "8px",
    boxShadow: "none",
    padding: 1,
    cursor: disabled ? "not-allowed" : "pointer",
    width,
    height,
    mb: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: iconSpacing,
    "&:hover": {
      backgroundColor: "var(--brand-700)",
      boxShadow: "none",
    },
    "& .MuiButton-startIcon, & .MuiButton-endIcon": {
      margin: "4px 0px",
    },
  };

  const mergedStyles = {
    ...defaultStyles,
    ...sx,
    "&:hover": {
      ...defaultStyles["&:hover"],
      ...(sx["&:hover"] || {}),
    },
  };

  const getContent = () => {
    if (loading) {
      return (
        <>
          <CircularProgress
            size={18}
            sx={{
              mr: 1,
              color: "var(--gray-0)", 
            }}
          />
          <Typography
            component="span"
            sx={{ color: "var(--gray-0)", fontWeight: 500,fontSize:"15px" }}
          >
            {loadingText || "Loading..."}
          </Typography>
        </>
      );
    }

    return (
      <>
        {(startAdornment || (iconPosition === "start" && IconComponent)) && (
          <Box sx={{ display: "flex", mr: iconSpacing }}>
            {startAdornment || IconComponent}
          </Box>
        )}

        <Typography variant="bodySmallMedium">{label}</Typography>

        {(endAdornment || (iconPosition === "end" && IconComponent)) && (
          <Box sx={{ display: "flex", ml: iconSpacing }}>
            {endAdornment || IconComponent}
          </Box>
        )}
      </>
    );
  };

  return (
    <Button
      type={type}
      variant="contained"
      disabled={disabled || loading}
      onClick={onClick}
      sx={mergedStyles}
      {...props}
    >
      {getContent()}
    </Button>
  );
};
